var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EmptyColumn } from '../../common/models/standar-columns';
import { paginateDataAsync } from '../../common/helpers/paginate-data';
import React from 'react';
import { Column, DataTable, Row, TeachingLink } from '../../common';
import { SelectionMode, Toggle } from '../../fluent';
import { Grid } from '../../common/components/Grid';
export class RoleManager extends React.Component {
    constructor(props) {
        super(props);
        this.onChangedToggle = (item, isAssociated) => __awaiter(this, void 0, void 0, function* () {
            if (isAssociated) {
                yield this.props.onAddItem(item.IdRol);
            }
            else {
                yield this.props.onRemoveItem(item.IdRol);
            }
            this.dtRef.refreshTable();
        });
        this.state = {
            associateRoles: props.associateRoles || [],
            roles: props.roles || [],
            title: props.title || ''
        };
    }
    componentDidMount() {
        var _a;
        (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
    }
    componentWillReceiveProps(props) {
        this.setState({
            associateRoles: props.associateRoles || [],
            roles: props.roles || [],
            title: props.title || ''
        }, () => {
            var _a;
            (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
        });
    }
    render() {
        return React.createElement(DataTable, { allowSearch: true, searchTooltip: 'Filtra los roles existentes del sistema', onDownloadServerData: (request) => {
                return paginateDataAsync(request, {
                    data: () => this.state.roles,
                    search: (item) => [item.Nombre],
                    onSort: (items) => {
                        items.ForEach(role => role.Seleccionado = this.state.associateRoles.includes(role.IdRol));
                        return items.OrderBy(o => o.Nombre).OrderBy(o => o.Seleccionado ? 1 : 2);
                    }
                });
            }, selectionMode: SelectionMode.none, ref: (e) => this.dtRef = e, columns: [
                {
                    key: 'Associated',
                    name: '',
                    fieldName: 'Associated',
                    minWidth: 60,
                    maxWidth: 60,
                    isResizable: false,
                    onRender: (item) => {
                        const isAsociated = this.state.associateRoles.find(o => o === item.IdRol) != null;
                        return React.createElement(Toggle, { checked: isAsociated, onChange: (_, checked) => this.onChangedToggle(item, checked) });
                    }
                },
                {
                    key: 'Nombre',
                    name: 'Nombre',
                    fieldName: 'Nombre',
                    isResizable: true,
                    minWidth: 350,
                    maxWidth: 500,
                    onRender: (item) => (React.createElement(TeachingLink, { id: item.IdRol, showPrimaryButton: false, text: item.Nombre, onOpenTeachingBubble: (complete) => complete(item), tooltip: item.Nombre, onRenderContent: () => React.createElement(React.Fragment, null,
                            React.createElement(Grid, null,
                                React.createElement(Row, null,
                                    React.createElement(Column, { size: 12 },
                                        React.createElement("span", { className: "section-link-title" }, "Direcci\u00F3n:"),
                                        React.createElement("span", { className: "section-link-text" }, item.Descripcion || 'Sin descripción'))))) }))
                },
                EmptyColumn
            ], title: this.state.title, hideHeaders: true });
    }
}
